import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const DatabaseOptionContainer = styled.div`
  display: inline-flex;
  align-items: flex-start;
  gap: ${token('space.100')};
`;

export const DatabaseOptionContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DatabaseOptionTitle = styled.div`
  font: ${token('font.body')};
  color: ${token('color.text', '#172B4D')};
`;
export const DatabaseOptionIcon = styled.span`
  padding-top: ${token('space.050', '4px')};
`;

export const DatabaseOptionInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${token('space.100', '8px')};

  font: ${token('font.body.small')};
  color: ${token('color.text.subtlest', '#6B778C')};
`;

export const ErrorMessage = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  font: ${token('font.body.UNSAFE_small')};
  padding-top: ${token('space.025', '2px')};
  gap: ${token('space.050', '4px')};
  color: ${token('color.text.danger', '#AE2A19')};
`;
